import Axios from "../utils/request";

// 订单 订单首页
export const loanappquery = (data) =>
  Axios({
    url: "/loan/loanappquery",
    method: "post",
    data,
  });
// 订单 订单首页saas
export const loanappqueryList = (data) =>
  Axios({
    url: "/loan/saas/loanappqueryList",
    method: "post",
    data,
  });
// 订单 订单详情
export const loanappqueryDetail = (data) =>
  Axios({
    url: "/loan/saas/loanappqueryDetail",
    method: "post",
    data,
  });
// 订单 提现
export const withdrawal = (data) =>
  Axios({
    url: "/loan/saas/withdrawal",
    method: "post",
    data,
  });

// 订单 还款信息
export const getva = (data) =>
  Axios({
    url: "/loan/getva",
    method: "post",
    data,
  });

// 订单 订单详情 （还款页面）
export const repayment = (data) =>
  Axios({
    url: "/app/order/repayment",
    method: "get",
    data,
  });
// 订单 选择还款方式
export const repaymethod = (data) =>
  Axios({
    url: "/app/order/method",
    method: "get",
    data,
  });

// 订单 领取贷款校验
export const checkProduct = (data) =>
  Axios({
    url: "/app/order/checkProduct",
    method: "get",
    data,
  });
// 订单  获取贷款信息
export const getLoanInfo = (data) =>
  Axios({
    url: "/app/order/getLoanInfo",
    method: "get",
    data,
  });
// 订单 领取贷款
// /app/order/receiveLoan
export const receiveLoan = (data) =>
  Axios({
    url: "/app/order/receiveLoan",
    method: "get",
    data,
  });
// 再借一笔校验
export const checkReloaned = (data) =>
  Axios({
    url: "/app/order/checkReloaned",
    method: "get",
    data,
  });
// 获取用户银行卡列表
export const getUserBank = (data) =>
  Axios({
    url: "/app/order/getUserBank",
    method: "get",
    data,
  });
// 获取银行卡列表
export const getBankList = (data) =>
  Axios({
    url: "/query/bankcode",
    method: "post",
    data,
  });
// 获取具体还款方式信息
export const getRepaymentInfo = (data) =>
  Axios({
    url: "/app/order/getRepaymentInfo",
    method: "get",
    data,
  });
// 再借一笔贷款申请
export const reloaned = (data) =>
  Axios({
    url: "/app/order/reloaned",
    method: "get",
    data,
  });
// 再借一笔贷款申请
export const addBankInfo = (data) =>
  Axios({
    url: "/app/order/addBankInfo",
    method: "post",
    data,
  });

// 订单  获取贷款信息  前置的确认借款页跳转 beforeLoanDetail
export const confirmOrderPage = (data) =>
  Axios({
    url: "/app/order/confirmOrderPage",
    method: "get",
    data,
  });

//查询新户是否可借
export const queryUserLoanStatus = (data) =>
  Axios({
    url: "/loan/queryUserLoanStatus",
    method: "post",
    data,
  });
//查询用户商户是否可借
export const querySaasLoanStatus = (data) =>
  Axios({
    url: "/loan/querySaasLoanStatus",
    method: "post",
    data,
  });
